import type { Lootbox } from '@/api/common';
import { USER_GROUP } from '@/helpers/user';

export const DAILY_LIMIT = 5;

export enum EScratchTicketTheme {
  BASIC = 'basic',
  PREMIUM = 'premium',
}

export const SCRATCH_GAME_RESTRICTED_GROUPS = [
  USER_GROUP.BA,
  USER_GROUP.BR,
  USER_GROUP.DEV_TEST,
  USER_GROUP.VIPBA,
];

export const LOOTBOX_SCRATCH_TITLES = ['Scratch_game', 'scratch_game'];

export const isScratchLootbox = (lootbox: Lootbox) =>
  LOOTBOX_SCRATCH_TITLES.some((LOOTBOX_SCRATCH_TITLES) =>
    lootbox.title.includes(LOOTBOX_SCRATCH_TITLES)
  );

export const indexToTheme = [
  EScratchTicketTheme.BASIC,
  EScratchTicketTheme.PREMIUM,
];

export const SCRATCH_GAME_CONFIG = {
  default: {
    [EScratchTicketTheme.BASIC]: {
      code: 'LIGHTS',
      minDep: 50,
      fsPrizes: {
        fs1: 30,
        fs2: 40,
        fs3: 60,
      },
      cashPrizes: {
        cash1: 5,
        cash2: 10,
        cash3: 15,
      },
    },
    [EScratchTicketTheme.PREMIUM]: {
      code: 'POPCORN',
      minDep: 100,
      fsPrizes: {
        fs1: 70,
        fs2: 90,
        fs3: 130,
      },
      cashPrizes: {
        cash1: 15,
        cash2: 25,
        cash3: 35,
      },
    },
  },
  vip: {
    [EScratchTicketTheme.BASIC]: {
      code: 'BOXV',
      minDep: 100,
      fsPrizes: {
        fs1: 70,
        fs2: 90,
        fs3: 130,
      },
      cashPrizes: {
        cash1: 15,
        cash2: 25,
        cash3: 35,
      },
    },
    [EScratchTicketTheme.PREMIUM]: {
      code: 'POPX',
      minDep: 200,
      fsPrizes: {
        fs1: 100,
        fs2: 150,
        fs3: 200,
      },
      cashPrizes: {
        cash1: 40,
        cash2: 60,
        cash3: 80,
      },
    },
  },
};
